import { useCallback, useEffect, useState } from 'react'

import { useQuery, useReactiveVar } from '@apollo/client'
import { add, differenceInDays } from 'date-fns'

import { store } from '../cache'
import { APPOINTMENT_AVAILABILITY } from '../queries/appointmentAvailability'
import { toISOStringDate } from '../utils/toISOStringDate'

// ? Fetched range does not inlcude full availability for the last month in the range (Ex, Aug 22 - Jun 22)
export function useAvailability(dayRange = 60, currentDate) {
  const today = new Date()
  const [startDate, setStartDate] = useState(today)
  const endDate = add(startDate, { days: dayRange })
  const { locationId } = useReactiveVar(store)
  const [serviceUnavailable, setServiceUnavailable] = useState(false)
  const [invalidStartDate, setInvalidStartDate] = useState(false)
  const [uncaughtError, setUncaughtError] = useState(false)
  const [appointmentTypes, setAppointmentTypes] = useState([])
  const [appointments, setAppointments] = useState([])

  const { data, loading, error } = useQuery(APPOINTMENT_AVAILABILITY, {
    variables: {
      locationId,
      startDateUtc: toISOStringDate(startDate),
      endDateUtc: toISOStringDate(endDate),
    },
  })

  useEffect(() => {
    if (!loading && !error) {
      switch (data.pmsAvailableAppointments.__typename) {
        case 'PmsAvailableAppointments':
          const fetchedTypes =
            data.pmsAvailableAppointments.appointmentTypeAvailability
          if (fetchedTypes.length === 0) {
          } else {
            setAppointmentTypes(fetchedTypes)
          }
          const fetchedAppointments = data.pmsAvailableAppointments.appointments
          if (fetchedAppointments.length === 0) {
          } else {
            const combinedAppointments =
              fetchedAppointments.concat(appointments)
            setAppointments(combinedAppointments)
          }
          break
        case 'VendorServiceUnavailable':
          setServiceUnavailable(true)
          break
        case 'InvalidStartDate':
          setInvalidStartDate(true)
          break
        default:
          setUncaughtError(true)
          break
      }
    }
  }, [data, loading, error])

  const loadNextBatch = useCallback(() => {
    setStartDate(endDate)
  }, [endDate])

  useEffect(() => {
    if (differenceInDays(currentDate, endDate) > 0) {
      loadNextBatch()
    }
  }, [currentDate, endDate])

  return {
    appointmentTypes,
    appointments,
    serviceUnavailable,
    invalidStartDate,
    uncaughtError,
    loading,
    error,
  }
}
